import { defineStore, setMapStoreSuffix } from 'pinia'

setMapStoreSuffix('')
export const useMicrositeStore = defineStore('MicrositeStore', {
  state: () => ({
    sizeView: null,
    fontSize: 0,
  }),
  actions: {
    setSizeView(sizeView) {
      this.sizeView = sizeView
    },
    setFontSize(fontSize) {
      this.fontSize = fontSize
    },
  },
})
